import React, { useState } from 'react';
import { useGameStore } from '../../stores/gameStore';
import { LeaderboardEntry } from '../../shared/types';

const MOCK_LEADERBOARD: LeaderboardEntry[] = [
  { rank: 1, userId: '1', username: 'ShadowStrike', avatar: '', value: 285000, rank_tier: 'legend' },
  { rank: 2, userId: '2', username: 'PhantomAce', avatar: '', value: 215000, rank_tier: 'master' },
  { rank: 3, userId: '3', username: 'NeonBlade', avatar: '', value: 189000, rank_tier: 'master' },
  { rank: 4, userId: '4', username: 'CrimsonFury', avatar: '', value: 156000, rank_tier: 'diamond' },
  { rank: 5, userId: '5', username: 'VoidWalker', avatar: '', value: 134000, rank_tier: 'diamond' },
  { rank: 6, userId: '6', username: 'StormBreaker', avatar: '', value: 112000, rank_tier: 'diamond' },
  { rank: 7, userId: '7', username: 'IronPulse', avatar: '', value: 98000, rank_tier: 'platinum' },
  { rank: 8, userId: '8', username: 'SilentKill', avatar: '', value: 87000, rank_tier: 'platinum' },
  { rank: 9, userId: '9', username: 'BlazeRunner', avatar: '', value: 76000, rank_tier: 'platinum' },
  { rank: 10, userId: '10', username: 'TitanForce', avatar: '', value: 65000, rank_tier: 'gold' },
];

const RANK_COLORS: Record<string, string> = {
  legend: '#ff1744', master: '#7c4dff', diamond: '#b9f2ff',
  platinum: '#00e5ff', gold: '#ffd700', silver: '#c0c0c0', bronze: '#cd7f32',
};

export function LeaderboardScreen() {
  const setScreen = useGameStore(s => s.setScreen);
  const [category, setCategory] = useState('xp');
  const categories = [
    { id: 'xp', label: 'Experience' },
    { id: 'kills', label: 'Total Kills' },
    { id: 'wins', label: 'Wins' },
    { id: 'creator', label: 'Creators' },
    { id: 'streak', label: 'Kill Streak' },
  ];

  return (
    <div className="w-full h-full flex flex-col bg-cf-black">
      <div className="flex items-center justify-between px-6 py-4 border-b border-cf-border">
        <h2 className="text-xl font-bold text-cf-white">Leaderboards</h2>
        <button onClick={() => setScreen('menu')} className="cf-btn-secondary text-xs">Back</button>
      </div>

      <div className="flex-1 overflow-hidden max-w-3xl mx-auto w-full">
        <div className="flex gap-2 px-6 py-3 border-b border-cf-border">
          {categories.map((cat) => (
            <button
              key={cat.id}
              onClick={() => setCategory(cat.id)}
              className={`px-3 py-1.5 rounded-lg text-xs font-semibold transition-all ${
                category === cat.id
                  ? 'bg-cf-cyan/10 text-cf-cyan border border-cf-cyan/20'
                  : 'text-cf-muted hover:text-cf-text'
              }`}
            >
              {cat.label}
            </button>
          ))}
        </div>

        <div className="overflow-y-auto">
          {MOCK_LEADERBOARD.map((entry) => {
            const color = RANK_COLORS[entry.rank_tier] || '#6b7280';
            return (
              <div
                key={entry.userId}
                className="flex items-center gap-4 px-6 py-3 border-b border-cf-border/30 hover:bg-cf-dark/30 transition-colors"
              >
                <div className={`w-8 h-8 rounded-lg flex items-center justify-center text-sm font-black ${
                  entry.rank <= 3 ? 'text-cf-amber' : 'text-cf-muted'
                }`}
                  style={{
                    backgroundColor: entry.rank <= 3 ? (entry.rank === 1 ? '#ffd70030' : entry.rank === 2 ? '#c0c0c030' : '#cd7f3230') : '#1a1d26',
                    border: `1px solid ${entry.rank <= 3 ? color + '40' : '#2a2e3d'}`,
                  }}
                >
                  {entry.rank}
                </div>

                <div className="w-10 h-10 rounded-xl bg-cf-dark flex items-center justify-center font-bold text-sm" style={{ color }}>
                  {entry.username.charAt(0)}
                </div>

                <div className="flex-1">
                  <div className="font-semibold text-cf-white text-sm">{entry.username}</div>
                  <div className="text-[10px] uppercase font-bold" style={{ color }}>
                    {entry.rank_tier}
                  </div>
                </div>

                <div className="text-right">
                  <div className="font-mono font-bold text-cf-white">{(entry.value / 1000).toFixed(1)}K</div>
                  <div className="text-[10px] text-cf-muted uppercase">{category}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
